var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle, _path11, _circle2, _path12, _circle3, _path13, _path14, _path15, _path16, _circle4, _path17, _circle5, _path18, _circle6, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _circle7, _path26, _circle8, _path27, _circle9, _path28, _path29, _path30, _circle10, _path31, _circle11, _path32, _circle12, _path33;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDataIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st1{fill:#69ebfc}.st4{fill:#d476e2}.st5{fill:#5861c7}.st7{fill:#6770e6}.st10{fill:#ea82fa}.st21{fill:#8f95e6}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M56 32H8a8 8 0 0 1 0-16h48a8 8 0 0 1 0 16z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M46 16H18V8a8 8 0 0 1 8-8h12a8 8 0 0 1 8 8v8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M54 23H6v-8a8 8 0 0 1 8-8h32a8 8 0 0 1 8 8v8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M46 18H18v-8a8 8 0 0 1 8-8h12a8 8 0 0 1 8 8v8z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M54 25H6v-8a8 8 0 0 1 8-8h32a8 8 0 0 1 8 8v8z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M31 29h2v19h-2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M57 48h-2v-7H9v7H7v-7c0-1.103.897-2 2-2h46c1.103 0 2 .897 2 2v7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M40 50H25a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h15a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M25 50h15v1H25zM25 57h15v1H25z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M40 57H25a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h15a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1zM40 64H25a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h15a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 27,
    cy: 47,
    r: 1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M36 48h-5a1 1 0 0 1 0-2h5a1 1 0 0 1 0 2z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 27,
    cy: 54,
    r: 1
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M36 55h-5a1 1 0 0 1 0-2h5a1 1 0 0 1 0 2z"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 27,
    cy: 61,
    r: 1
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M36 62h-5a1 1 0 0 1 0-2h5a1 1 0 0 1 0 2z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M40 15H25a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h15a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M25 15h15v1H25zM25 22h15v1H25z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M40 22H25a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h15a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1zM40 29H25a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h15a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 27,
    cy: 12,
    r: 1
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M36 13h-5a1 1 0 0 1 0-2h5a1 1 0 0 1 0 2z"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 27,
    cy: 19,
    r: 1
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M36 20h-5a1 1 0 0 1 0-2h5a1 1 0 0 1 0 2z"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 27,
    cy: 26,
    r: 1
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M36 27h-5a1 1 0 0 1 0-2h5a1 1 0 0 1 0 2z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M63 50H48a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h15a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M63 44H48a1 1 0 0 0-1 1v1a1 1 0 0 1 1-1h15a1 1 0 0 1 1 1v-1a1 1 0 0 0-1-1zM40 44H25a1 1 0 0 0-1 1v1a1 1 0 0 1 1-1h15a1 1 0 0 1 1 1v-1a1 1 0 0 0-1-1zM40 9H25a1 1 0 0 0-1 1v1a1 1 0 0 1 1-1h15a1 1 0 0 1 1 1v-1a1 1 0 0 0-1-1z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M16 50H1a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h15a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M16 44H1a1 1 0 0 0-1 1v1a1 1 0 0 1 1-1h15a1 1 0 0 1 1 1v-1a1 1 0 0 0-1-1z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M48 50h15v1H48zM48 57h15v1H48z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M63 57H48a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h15a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1zM63 64H48a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h15a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 50,
    cy: 47,
    r: 1
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M59 48h-5a1 1 0 0 1 0-2h5a1 1 0 0 1 0 2z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 50,
    cy: 54,
    r: 1
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M59 55h-5a1 1 0 0 1 0-2h5a1 1 0 0 1 0 2z"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 50,
    cy: 61,
    r: 1
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M59 62h-5a1 1 0 0 1 0-2h5a1 1 0 0 1 0 2zM1 50h15v1H1zM1 57h15v1H1z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M16 57H1a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h15a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1zM16 64H1a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h15a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M16 63H1a1 1 0 0 1-1-1v1a1 1 0 0 0 1 1h15a1 1 0 0 0 1-1v-1a1 1 0 0 1-1 1z"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 3,
    cy: 47,
    r: 1
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M12 48H7a1 1 0 0 1 0-2h5a1 1 0 0 1 0 2z"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 3,
    cy: 54,
    r: 1
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M12 55H7a1 1 0 0 1 0-2h5a1 1 0 0 1 0 2z"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 3,
    cy: 61,
    r: 1
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M12 62H7a1 1 0 0 1 0-2h5a1 1 0 0 1 0 2zM40 63H25a1 1 0 0 1-1-1v1a1 1 0 0 0 1 1h15a1 1 0 0 0 1-1v-1a1 1 0 0 1-1 1zM63 63H48a1 1 0 0 1-1-1v1a1 1 0 0 0 1 1h15a1 1 0 0 0 1-1v-1a1 1 0 0 1-1 1z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataIcon);
export default __webpack_public_path__ + "static/media/data-icon.791dec52545948d90cd7d534e29a57e2.svg";
export { ForwardRef as ReactComponent };